/** Types for the label template editor */

export type ElementType = 'text' | 'datamatrix' | 'datamatrix_ka' | 'gs1_128' | 'ean13' | 'line' | 'rect'

export interface LabelElement {
  id: string
  type: ElementType
  x: number
  y: number
  width: number
  height: number
  rotation?: number
  // text-specific
  field?: string
  label?: string
  fontSize?: number
  fontWeight?: string
  align?: string
}

export interface TemplateData {
  name: string
  type: string
  width: number
  height: number
  elements: LabelElement[]
  for_km?: boolean
  for_ka_box?: boolean
  for_ka_pallet?: boolean
}

export const ELEMENT_TYPE_NAMES: Record<ElementType, string> = {
  text: 'Текст',
  datamatrix: 'GS1-DataMatrix',
  datamatrix_ka: 'GS1-DataMatrix (КА)',
  gs1_128: 'GS1-128',
  ean13: 'EAN-13',
  line: 'Линия',
  rect: 'Рамка',
}

export const ELEMENT_DEFAULTS: Record<ElementType, Partial<LabelElement>> = {
  text: { width: 50, height: 10, fontSize: 10, rotation: 0 },
  datamatrix: { width: 20, height: 20, field: 'km_code', rotation: 0 },
  datamatrix_ka: { width: 30, height: 30, field: 'ka_code', rotation: 0 },
  gs1_128: { width: 60, height: 30, field: 'ka_code', rotation: 0 },
  ean13: { width: 40, height: 20, field: 'gtin', rotation: 0 },
  line: { width: 50, height: 0.5, rotation: 0 },
  rect: { width: 50, height: 30, rotation: 0 },
}

export const DATA_FIELDS = [
  'gtin',
  'production_date',
  'expiry_date',
  'ka_code',
  'sequence_number',
  'task_name',
  'task_id',
] as const

export const TOOLBOX_ITEMS: { type: ElementType; label: string }[] = [
  { type: 'text', label: 'Текст' },
  { type: 'datamatrix', label: 'GS1-DataMatrix' },
  { type: 'gs1_128', label: 'GS1-128' },
  { type: 'ean13', label: 'EAN-13' },
]

export interface PreviewTestData {
  product_name: string
  product_code: string
  gtin: string
  km_code: string
  ka_code: string
  task_id: string
  task_name: string
  production_date: string
  expiry_date: string
  box_num: number
  pallet_num: number
  codes_count: number
  sequence_number: number
  first_sequence: number
  last_sequence: number
  sequence_range: string
  first_box: number
  last_box: number
  box_range: string
  km_in_box: number
  km_on_pallet: number
}

export const DEFAULT_TEST_DATA: PreviewTestData = {
  product_name: 'Тестовый товар',
  product_code: 'ABC123',
  gtin: '04810285016605',
  km_code: '010481028501660521ABC1234567890',
  ka_code: '(01)04810285016605(37)10',
  task_id: 'TASK-2025-001',
  task_name: 'Задание #2025-001',
  production_date: '15.01.2025',
  expiry_date: '15.01.2026',
  box_num: 1,
  pallet_num: 1,
  codes_count: 50,
  sequence_number: 1,
  first_sequence: 1,
  last_sequence: 50,
  sequence_range: '1-50',
  first_box: 1,
  last_box: 5,
  box_range: '1-5',
  km_in_box: 24,
  km_on_pallet: 480,
}
